import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { STRINGS } from "../../utils/strings";

export default function Title() {
  return (
    <div className="w-full">
      <Typography
        className={`w-full text-[32px] font-semibold`}
        style={{ color: HNSColors.primary[500] }}
      >
        {STRINGS.PAGE_TITLE}
      </Typography>
    </div>
  );
}
